import { SEO } from "../../SEO";
import { PageHero } from './PageHero';

export const ArbitroAssicurativo = ({ pageName }) => {
    const PDFDownload = () => {
        fetch('arbitro_informativa_comunian_zanetti.pdf').then(response => {
            response.blob().then(blob => {
                const fileURL = window.URL.createObjectURL(blob);
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = 'arbitro_informativa_comunian_zanetti.pdf';
                alink.click();
            })
        })
    }

    return (
        <>
            <SEO
                title="Comunian & Zanetti - Arbitro Assicurativo"
                description="Informativa ai clienti sulla possibilità di ricorso all'Arbitro delle controversie assicurative (AAS)."
            />

            <PageHero pageName={pageName} pageTitle="Arbitro Assicurativo" />

            <section className="o-page-content u-flex u-flex-col">
                <section className="o-content-paragraph u-flex u-flex-col">

                    <h2>Informativa ai Clienti</h2>
                    <p><strong>Possibilità di ricorso all'Arbitro delle controversie assicurative (AAS)</strong></p>

                    <p>
                        La società <strong>COMUNIAN E ZANETTI ASSICURATORI S.N.C. DI COMUNIAN MATTEO E ZANETTI ANDREA</strong>,
                        in qualità di intermediario assicurativo iscritto al RUI con codice <strong>A000656299</strong>,
                        informa i propri clienti che, per qualsiasi controversia derivante da contratti di assicurazione conclusi,
                        è possibile presentare un ricorso all'Arbitro delle controversie assicurative (AAS),
                        secondo quanto previsto dalla normativa applicabile e dalle Disposizioni tecniche IVASS.
                    </p>

                    <p>
                        L'AAS è un organismo autonomo ed imparziale istituito ai sensi del <strong>DM 6 novembre 2024, n. 215</strong> e
                        delle Disposizioni tecniche IVASS.
                    </p>

                    <h3>Quando presentare ricorso</h3>
                    <p>
                        Il ricorso può essere presentato <strong>entro 12 mesi</strong> dalla data di invio del reclamo,
                        a condizione che il reclamo sia stato previamente trasmesso e che:
                    </p>
                    <ul className="o-list">
                        <li>non sia pervenuta risposta entro il termine di legge (<strong>45 giorni</strong>), oppure</li>
                        <li>la risposta ricevuta non sia ritenuta soddisfacente.</li>
                    </ul>

                    <h3>Limiti di valore delle controversie</h3>
                    <ul className="o-list">
                        <li>Polizze danni: fino a <strong>€ 25.000</strong></li>
                        <li>Polizze vita: <strong>€ 150.000</strong> o <strong>€ 300.000</strong> a seconda del tipo</li>
                    </ul>

                    <h3>Procedura online</h3>
                    <p>La procedura è disponibile esclusivamente online all'indirizzo:</p>
                    <p className="o-arbitro-link">
                        <a href="https://www.arbitroassicurativo.org" target="_blank" rel="noopener noreferrer">
                            www.arbitroassicurativo.org
                        </a>
                    </p>

                    <p>
                        Per le controversie transfrontaliere può essere applicabile la rete <strong>FIN-NET</strong>:
                        {" "}
                        <a
                            href="https://finance.ec.europa.eu/consumer-finance-and-payments/retail-financial-services/financial-dispute-resolution-network-fin-net_it"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            informazioni su FIN-NET
                        </a>
                        .
                    </p>

                    <h3>Costi</h3>
                    <p>
                        È previsto un contributo di attivazione di <strong>€ 20</strong>.
                        Il contributo verrà restituito se il ricorso sarà accolto in tutto o in parte.
                    </p>

                    <h3>Assistenza</h3>
                    <p>
                        Non è richiesta l'assistenza di un legale, ma il cliente può farsi assistere da un professionista o
                        da un'associazione di consumatori.
                    </p>

                    <p>
                        Sul sito dell'AAS è disponibile una <strong>GUIDA</strong> per l'utilizzo dello strumento e
                        una sezione <strong>FAQ</strong> con tutti i chiarimenti.
                    </p>

                    <hr className="o-divider" />

                    <h2>Come proporre un eventuale reclamo</h2>

                    <p>
                        Il Contraente ha la facoltà, ferma restando la possibilità di rivolgersi all'Autorità Giudiziaria,
                        di inoltrare <strong>RECLAMO per iscritto</strong> all'Intermediario (reclami relativi alla sua condotta
                        ovvero a quella dei suoi dipendenti o collaboratori) ai seguenti recapiti:
                    </p>

                    <ul className="o-list">
                        <li>Mail: <a href="mailto:info@comunianezanetti.it">info@comunianezanetti.it</a></li>
                        <li>PEC: <a href="mailto:comunianezanettisnc@legalmail.it">comunianezanettisnc@legalmail.it</a></li>
                        <li>Indirizzo: Strada Battaglia, 129 - 35020 Albignasego (PD)</li>
                    </ul>

                    <br></br>

                    <p>
                        Analogamente il Contraente ha la facoltà di inoltrare il proprio eventuale reclamo (avente ad oggetto
                        la gestione del rapporto contrattuale ovvero la gestione dei sinistri) all'Impresa di assicurazione preponente,
                        ai recapiti indicati nel documento denominato DIP aggiuntivo.
                    </p>

                    <p>
                        <em>
                            <strong>N.B.</strong> Un "reclamo" è una dichiarazione d'insoddisfazione in forma scritta nei confronti
                            di un'Impresa di assicurazione, di un Intermediario assicurativo ovvero di un Intermediario iscritto nell'elenco annesso,
                            relativa ad un contratto oppure ad un servizio assicurativo; non sono considerati reclami le richieste di informazioni
                            o di chiarimenti, le richieste di risarcimento danni o di esecuzione del contratto.
                        </em>
                    </p>

                    <p>
                        Qualora il contraente non dovesse ritenersi soddisfatto dall'esito del reclamo ovvero in caso di assenza di riscontro
                        da parte dell'Intermediario o dell'Impresa di assicurazione entro il termine di legge (<strong>45 giorni</strong>), il Contraente potrà
                        rivolgersi direttamente all'<strong>IVASS - Istituto per la vigilanza sulle assicurazioni</strong>,
                        secondo quanto previsto nei DIP aggiuntivi.
                    </p>

                    <hr className="o-divider" />

                    <div className="o-download-section">
                        <button className="o-footer-button o-download-button" aria-label="Scarica Informativa AAS (PDF)" onClick={PDFDownload}>
                            Scarica Informativa AAS
                        </button>
                    </div>

                </section>
            </section>

        </>
    )
}
